class AffindaClient
{
    private affindaURL: string;
    private collectionId: string;
    private workspaceId: string;
    private apiKey: string;
    constructor()
    {
        this.affindaURL = 'https://api.affinda.com/v3/documents';
        this.collectionId = process.env.VUE_APP_AFFINA_COLLECTION_ID || '';
        this.workspaceId = process.env.VUE_APP_AFFINA_WORKSPACE_ID || '';
        this.apiKey = process.env.VUE_APP_AFFINDA_API_KEY || '';
    }

    public createResume = async (file: File) =>
    {
      const form = new FormData();

      form.append('wait', 'true');
      form.append('collection',  this.collectionId);
      form.append('workspace', this.workspaceId);
      form.append('file', file);

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          authorization: `Bearer ${this.apiKey}`
        }, 
        body: form
      };

      try {
        const response = await fetch(this.affindaURL, options)
        const data = await response.json();

        // Delete the document after it has been processed to avoid overflow Affinda storage
        const identifier = data.meta.identifier;
        await this.deleteDocument(identifier);

        return data;
      } catch (err) {
        console.error(err);
        return null;
      }

    }

    public deleteDocument = async (identifier: string) =>
    {

      const options = {
        method: 'DELETE',
        headers: {
          accept: 'application/json',
          authorization: `Bearer ${this.apiKey}`
        }, 
      };

      try {
        const response = await fetch(`${this.affindaURL}/${identifier}`, options);
        const data = await response.json();
        console.log('DELETE')
        console.log(data)
        return data;
      } catch (err) {
        console.error(err);
        return null;
      }
    }
}

export default AffindaClient;